import { render } from "./MultisidebarContentNotFound.vue?vue&type=template&id=2083d3e1&ts=true"
import script from "./MultisidebarContentNotFound.vue?vue&type=script&lang=ts"
export * from "./MultisidebarContentNotFound.vue?vue&type=script&lang=ts"

import "./MultisidebarContentNotFound.vue?vue&type=style&index=0&id=2083d3e1&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__